import React, { useEffect, useState } from "react";
import { FaEnvelope, FaPhoneAlt, FaTimes } from "react-icons/fa";
import supportIcon from "../../../assets/icons/supportIcon.svg";
import "./SupportWidget.scss";
import logo from "../../../assets/Image/rmsLogo.jpg";

const SupportWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  const isArabic = sessionStorage.getItem("language") === "ar";

  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === "Escape") {
        setIsOpen(false);
      }
    };

    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, []);

  return (
    <div className="support-widget">
      {isOpen && (
        <div
          id="support-modal"
          className="support-modal"
          role="dialog"
          aria-modal="true"
          aria-labelledby="support-title"
        >
          <button
            type="button"
            className="support-modal-close"
            onClick={() => setIsOpen(false)}
            aria-label={isArabic ? "إغلاق نافذة الدعم" : "Close support dialog"}
          >
            <FaTimes />
          </button>

          <div className="support-modal-header">
            <img src={logo} alt="" className="support-avatar" />
            <div>
              <p className="support-eyebrow">
                {isArabic ? "نحن هنا لمساعدتك" : "We are here to help"}
              </p>
              <h2 id="support-title">
                {isArabic ? "هل تحتاج إلى المساعدة؟" : "Need help?"}
              </h2>
            </div>
          </div>

          <p className="support-modal-text">
            {isArabic
              ? "راحتكم تهمنا. إذا كنتم بحاجة إلى المساعدة بشأن مطالبتكم، يرجى مراسلة فريق الدعم لدينا عبر البريد الإلكتروني."
              : "Your peace of mind matters to us. If you need a helping hand with your claim, please email our support team."}
          </p>

          <div className="support-modal-actions">
            <a
              href="tel:+96824762600"
              className="support-action support-action-primary"
            >
              <FaPhoneAlt />
              <span>{isArabic ? "اتصل بنا" : "Call us"}</span>
            </a>
            <a
              href="mailto:branches@rmsme.om"
              className="support-action support-action-secondary"
            >
              <FaEnvelope />
              <span>{isArabic ? "راسلنا" : "Email us"}</span>
            </a>
          </div>

          {/* <p className="support-contact-detail">
            +968 24762600 · branches@rmsme.om
          </p> */}
        </div>
      )}

      <button
        type="button"
        className={`support-trigger ${isOpen ? "is-open" : ""}`}
        onClick={() => setIsOpen((open) => !open)}
        aria-expanded={isOpen}
        aria-controls="support-modal"
        aria-label={isArabic ? "فتح الدعم" : "Open support"}
      >
        {isOpen ? <FaTimes /> : <img src={supportIcon} alt="" />}
        <span>{isArabic ? "الادعاءات الداعمة" : "Claims Support"}</span>
      </button>
    </div>
  );
};

export default SupportWidget;
